import React, { Component } from 'react';
import { motion } from 'framer-motion';
const SolutionSection = () => {
  return <section className="w-full bg-gradient-to-b from-white via-orange-50/20 to-white py-16 sm:py-24 md:py-32 lg:py-48" data-id="element-1042">
      <div className="container mx-auto px-4 sm:px-6 md:px-8" data-id="element-1043">
        <div className="max-w-4xl mx-auto text-center" data-id="element-1044">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 sm:mb-8 tracking-tight leading-tight" data-id="element-1045">
            Agentic UI: where AI executes inside the product
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-lg sm:text-xl md:text-2xl text-gray-600 mb-4 sm:mb-6 leading-relaxed max-w-3xl mx-auto" data-id="element-1046">
            FluidWeb gives you agentic interfaces — UI surfaces designed for AI
            execution, not just suggestions. Each surface runs on the same
            policy + orchestration runtime, so actions are constrained,
            observable, and repeatable.
          </motion.p>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="text-base sm:text-lg text-gray-500 mb-12 sm:mb-14 md:mb-16 italic" data-id="element-1047">
            Components are the surface. The platform is the guarantee.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="max-w-2xl mx-auto" data-id="element-1048">
            <div className="text-xs text-gray-400 uppercase tracking-wider font-semibold mb-3 text-left px-2" data-id="element-1049">
              Policy Envelope / Execution Contract
            </div>
            <div className="bg-gray-900 rounded-xl sm:rounded-2xl shadow-2xl overflow-hidden border border-gray-800 font-mono text-xs sm:text-sm text-left" data-id="element-1050">
              <div className="flex items-center px-3 sm:px-4 py-2 sm:py-3 bg-gray-950 border-b border-gray-800 gap-2" data-id="element-1051">
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-500" data-id="element-1052" />
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-yellow-500" data-id="element-1053" />
                <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-500" data-id="element-1054" />
              </div>
              <div className="p-4 sm:p-6 md:p-8 text-gray-300 leading-relaxed overflow-x-auto" data-id="element-1055">
                <div className="flex" data-id="element-1056">
                  <span className="text-purple-400" data-id="element-1057">{'<'}</span>
                  <span className="text-yellow-300" data-id="element-1058">FluidWeb</span>
                </div>
                <div className="flex pl-2 sm:pl-4" data-id="element-1059">
                  <span className="text-blue-300" data-id="element-1060">tools</span>
                  <span className="text-white" data-id="element-1061">=</span>
                  <span className="text-white" data-id="element-1062">{'{['}</span>
                  <span className="text-green-400" data-id="element-1063">createVendor</span>
                  <span className="text-white" data-id="element-1064">, </span>
                  <span className="text-green-400" data-id="element-1065">runReport</span>
                  <span className="text-white" data-id="element-1066">{']}'}</span>
                </div>
                <div className="flex pl-2 sm:pl-4" data-id="element-1067">
                  <span className="text-blue-300" data-id="element-1068">autonomy</span>
                  <span className="text-white" data-id="element-1069">=</span>
                  <span className="text-green-400" data-id="element-1070">"supervised"</span>
                </div>
                <div className="flex pl-2 sm:pl-4" data-id="element-1071">
                  <span className="text-blue-300" data-id="element-1072">policy</span>
                  <span className="text-white" data-id="element-1073">={'{'}</span>
                  <span className="text-white" data-id="element-1074">{'{'}</span>
                </div>
                <div className="flex pl-4 sm:pl-8" data-id="element-1075">
                  <span className="text-blue-300" data-id="element-1076">requireApproval</span>
                  <span className="text-white" data-id="element-1077">: [</span>
                  <span className="text-green-400" data-id="element-1078">'payments'</span>
                  <span className="text-white" data-id="element-1079">]</span>
                </div>
                <div className="flex pl-2 sm:pl-4" data-id="element-1080">
                  <span className="text-white" data-id="element-1081">{'}}'}</span>
                </div>
                <div className="flex" data-id="element-1082">
                  <span className="text-purple-400" data-id="element-1083">{'/>'}</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default SolutionSection;